import React from 'react';
import styled from '@emotion/styled';
import BucketListView from './views/BucketListView';
import GlobalStyles from './styles/GlobalStyles';

/**
 * Main app container with soft, dreamy aesthetic and cute padding
 */
const AppContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 30px 20px;
  color: #4a4a4a;
  position: relative;

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        circle at 20% 20%,
        rgba(255, 179, 217, 0.3) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 80% 80%,
        rgba(212, 179, 255, 0.3) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 40% 70%,
        rgba(255, 202, 179, 0.2) 0%,
        transparent 50%
      );
    pointer-events: none;
    z-index: -1;
  }
`;

const App: React.FC = () => {
  return (
    <>
      <GlobalStyles />
      <AppContainer>
        <main>
          <BucketListView />
        </main>
      </AppContainer>
    </>
  );
};

export default App;
